import { render, staticRenderFns } from "./IconBack.vue?vue&type=template&id=38b8edc2&scoped=true"
import script from "./IconBack.vue?vue&type=script&lang=js"
export * from "./IconBack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b8edc2",
  null
  
)

export default component.exports